import Swiper from 'swiper/bundle';


if ($('.slider-type-2').length) {
	$('.slider-type-2').each(function() {
		var $this = $(this);
		var section = $(this).closest('section');
		var pagination = section.find('.slider-pagination');

		// Match all slide contents to the tallest one; reset first so it re-measures on resize
		var setContentHeight = function() {
			var blocks = section.find('[data-slide-content] .block-content');
			blocks.css('height', '');
			let maxHeight = 0;
			blocks.each(function() {
				let contentHeight = $(this).outerHeight();
				if (contentHeight > maxHeight) {
					maxHeight = contentHeight;
				}
			});
			blocks.css('height', maxHeight);

			// lg–xl: text column pads itself above the awards using this (0 when awards are hidden)
			section[0].style.setProperty('--awards-height', (section.find('.awards-content').outerHeight() || 0) + 'px');
		};

		// Lazy-loaded award logos have no height until they load, so re-measure as each one arrives
		section.find('.awards-content img').on('load', setContentHeight);

		window.sliderType2 = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoHeight: false,
			autoplay: {
				delay: 4500,
				disableOnInteraction: false,
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			loop: true,
			navigation: false,
			on: {
				init: function () {
					var uid = $this.find('.swiper-slide-active').attr('data-slide');
					var currentSlideContent = section.find('[data-slide-content="' + uid + '"]');
					section.find('[data-slide-content]').attr('data-revealed', 'false')
					currentSlideContent.attr('data-revealed', 'true')

					setContentHeight();
				},
				slideChangeTransitionStart: function (swiper) {
					var uid = $this.find('.swiper-slide-active').attr('data-slide');
					var currentSlideContent = section.find('[data-slide-content="' + uid + '"]');
					section.find('[data-slide-content]').attr('data-revealed', 'false')
					currentSlideContent.attr('data-revealed', 'true')
				},
				resize: function () {
					setContentHeight();
				},
			},
		});
	})
}




if ($('.slider-rental-gallery').length) {
	var galleryThumb = new Swiper(".slider-rental-gallery-thumb", {
		spaceBetween: 10,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			640: {
				slidesPerView: 4,
			},
			768: {
				slidesPerView: 5,
			},
			1024: {
				slidesPerView: 7,
			},
			1280: {
				slidesPerView: 9,
			},
			1696: {
				slidesPerView: 10,
			},
		},
	});
	var galleryBig = new Swiper(".slider-rental-gallery", {
		spaceBetween: 10,
		navigation: {
			nextEl: $('[data-gallery]').find('.swiper-button-next')[0],
			prevEl: $('[data-gallery]').find('.swiper-button-prev')[0],
		},
		thumbs: {
			swiper: galleryThumb,
		},
		hashNavigation: {
			watchState: true,
		},
		watchSlidesProgress: true,
		on: {
			init: function () {
				// console.log('swiper initialized');
			},
			slideChangeTransitionStart: function (swiper) {
				console.log()
				$('[data-gallery] .slider-progress .current').text(swiper.realIndex + 1);
			},
		},
	});
}


function initType3Slider() {
	$('.slider-type-3').each(function(index) {
		var slider = $(this);
		var offsetEl = slider.closest('section').find('.column-left > *');
		var offset = offsetEl.offset().left;
		var pagination = slider.closest('section').find('.slider-pagination');

		// Destroy existing instance if it exists
		if (slider[0].swiper) {
			slider[0].swiper.destroy(true, true);
		}

		// Reinitialize with updated offset
		new Swiper(slider[0], {
			slidesPerView: 1.1,
			centeredSlides: false,
			spaceBetween: 14,
			speed: 600,
			autoHeight: true,
			autoplay: false,
			loop: false,
			scrollbar: false,
			navigation: false,
			slidesOffsetBefore: offset,
			slidesOffsetAfter: offset,
			navigation: {
				nextEl: slider.find('.swiper-button-next')[0],
				prevEl: slider.find('.swiper-button-prev')[0],
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.8,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 32,
				},
				1280: {
					slidesPerView: 2.5
				},
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	});
}

if ($('.slider-type-3').length) {
	let lastWindowWidth = window.innerWidth;

	initType3Slider();

	let resizeTimeout;
	$(window).on('resize', function () {
		// Only act on horizontal resize
		if (window.innerWidth !== lastWindowWidth) {
			lastWindowWidth = window.innerWidth;

			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(function () {
				initType3Slider();
			}, 300);
		}
	});
}

if ($('[data-section="galleryImages"]').length) {
	$('[data-section="galleryImages"]').each(function(index) {
		var slider = $(this).find('.slider-type-gallery');
		var prevArr = $(this).find('.swiper-button-prev')[0];
		var nextArr = $(this).find('.swiper-button-next')[0];
		var pagination = slider.closest('section').find('.slider-pagination');

		// Destroy existing instance if it exists
		if (slider[0].swiper) {
			slider[0].swiper.destroy(true, true);
		}

		//ensure more than 5
		var $slides = slider.find('.swiper-slide');
		if ($slides.length < 6) {
			const needed = 6 - $slides.length;
			for (var i = 0; i < needed; i++) {
				const $slideToClone = $slides.eq(i % $slides.length);
				const $clone = $slideToClone.clone(true);
				slider.find('.swiper-wrapper').append($clone);
			}
		} 

		// Reinitialize with updated offset
		new Swiper(slider[0], {
			slidesPerView: 1.25,
			centeredSlides: true,
			spaceBetween: 16,
			speed: 600,
			autoHeight: true,
			autoplay: false,
			loop: true,
			scrollbar: false,
			navigation: {
				nextEl: nextArr,
				prevEl: prevArr,
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: 1.75,
					spaceBetween: 32
				},
			},
		});
	});
}

if ($('[data-section="sliderType5"]').length) {
	function getContainerOffset() {
		const maxWidth = 1792;
		const styles = getComputedStyle(document.documentElement);
		const rem = parseFloat(styles.fontSize);
		
		// Parse the values and convert if they're in rem
		const rowPaddingRaw = styles.getPropertyValue('--row-padding').trim();
		const colPaddingRaw = styles.getPropertyValue('--col-padding').trim();
		
		const rowPadding = rowPaddingRaw.includes('rem') 
			? parseFloat(rowPaddingRaw) * rem 
			: parseFloat(rowPaddingRaw);
		
		const colPadding = colPaddingRaw.includes('rem') 
			? parseFloat(colPaddingRaw) * rem 
			: parseFloat(colPaddingRaw);
		
		const containerPadding = rowPadding + colPadding;
		const viewportWidth = $(window).width();
		
		if (viewportWidth >= maxWidth) {
			return ((viewportWidth - maxWidth) / 2) + containerPadding;
		}
		return containerPadding;
	}

	function initSliderType5() {
		$('[data-section="sliderType5"]').each(function() {
			var slider = $(this).find('.swiper');
			var offset = getContainerOffset();
			
			if (slider[0].swiper) {
				slider[0].swiper.destroy(true, true);
			}

			new Swiper(slider[0], {
				slidesPerView: 'auto',
				spaceBetween: 16,
				grabCursor: true,
				loop: false,
				scrollbar: false,
				speed: 600,
				autoplay: false,
				slidesOffsetBefore: offset,
				slidesOffsetAfter: offset,
				breakpoints: {
					1024: {
						spaceBetween: 32
					},
				},
			});
		});
	}

	initSliderType5();

	let lastWindowWidth = window.innerWidth;
	let resizeTimeout;
	$(window).on('resize', function() {
		if (window.innerWidth !== lastWindowWidth) {
			lastWindowWidth = window.innerWidth;
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(initSliderType5, 300);
		}
	});
}


// textType7 - project/development blocks
if ($('[data-section="textType7"]').length) {

	// move gallery asides to body so they escape the section's stacking context
	$('[data-tt7-gallery]').each(function() {
		$('body').append($(this).detach());
	});

	// inline block sliders (one per block)
	$('[data-section="textType7"]').each(function() {
		var section = $(this);
		var uid = section.attr('data-tt7-uid');
		var sliderEl = section.find('.tt7-slider')[0];
		var paginationEl = section.find('[data-tt7-pagination]')[0];
		if (!sliderEl) return;

		new Swiper(sliderEl, {
			slidesPerView: 1,
			loop: true,
			speed: 500,
			autoplay: false,
			pagination: {
				el: paginationEl,
				type: 'bullets',
				clickable: true,
			},
		});
	});

	// gallery swipers (one per block)
	$('[data-tt7-gallery]').each(function() {
		var uid = $(this).attr('data-tt7-gallery');
		var thumbEl = $('[data-tt7-gallery-thumb="' + uid + '"]')[0];
		var mainEl = $('[data-tt7-gallery-main="' + uid + '"]')[0];
		if (!thumbEl || !mainEl) return;

		var galleryThumb = new Swiper(thumbEl, {
			spaceBetween: 10,
			slidesPerView: 3,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				640: { slidesPerView: 4 },
				768: { slidesPerView: 5 },
				1024: { slidesPerView: 7 },
				1280: { slidesPerView: 9 },
				1696: { slidesPerView: 10 },
			},
		});

		new Swiper(mainEl, {
			spaceBetween: 10,
			navigation: {
				nextEl: $('[data-tt7-next="' + uid + '"]')[0],
				prevEl: $('[data-tt7-prev="' + uid + '"]')[0],
			},
			thumbs: { swiper: galleryThumb },
			watchSlidesProgress: true,
			on: {
				slideChangeTransitionStart: function(swiper) {
					$('[data-tt7-gallery="' + uid + '"] .tt7-progress-current').text(swiper.realIndex + 1);
				},
			},
		});
	});

	// open gallery on slide click
	$(document).on('click', '[data-tt7-reveal]', function(e) {
		var uid = $(this).attr('data-tt7-reveal');
		var index = parseInt($(this).attr('data-tt7-index') || 0);
		$('[data-tt7-gallery="' + uid + '"]').attr('data-revealed', 'true');
		var mainEl = $('[data-tt7-gallery-main="' + uid + '"]')[0];
		if (mainEl && mainEl.swiper) {
			mainEl.swiper.slideTo(index, 0);
		}
	});

	// close gallery
	$(document).on('click', '[data-tt7-close]', function(e) {
		$('[data-tt7-gallery]').attr('data-revealed', 'false');
	});
}